import React, { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

import { ItemCard } from '../components/ItemCard';
import { CardWrapper } from '../components/CardWrapper';
import { NewList } from '../components/list/NewList';
import { Loading } from '../components/Loading';

const db = firebase.firestore();

// TODO: Refactor how to refetch the data on mark item
//     the local state could update only based on a successful db write

export function Home() {
  const [lists, setLists] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const { intialising, user } = useAuthState(firebase.auth());

  useEffect(() => {
    const fetchData = async () => {
      if (!intialising && user) {
        const userDoc = await db.doc(`users/${user.uid}`).get();
        const data = userDoc.data();
        const householdUid = data && data.householdUid;
        const date = new Date();
        try {
          const listCollection = await db
            .collection('lists')
            .where('householdUid', '==', householdUid)
            .where('listDone', '==', false)
            .where(
              'time',
              '>=',
              new Date(date.getMonth(), date.getDate(), date.getFullYear())
            )
            .orderBy('time', 'desc')
            .limit(3)
            .get();
          const finalList = listCollection.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));

          if (listCollection) {
            setListLoading(false);
            setLists(finalList);
          }
        } catch (err) {
          setListLoading(false);
          console.log(err.message);
        }
      }
    };
    fetchData();
  }, []);

  const markItem = async (e, index, listId) => {
    e.preventDefault();
    const userDoc = await db.doc(`users/${user.uid}`).get();
    const { householdUid } = userDoc.data();

    const list = lists.filter(({ id }) => id === listId);
    const newList = { ...list[0] };
    const items = newList.items;
    const item = items[index];
    item.done = !item.done;
    await db
      .collection('lists')
      .doc(listId)
      .update({
        items
      });

    const date = new Date();
    const listCollection = await db
      .collection('lists')
      .where('householdUid', '==', householdUid)
      .where('listDone', '==', false)
      .where(
        'time',
        '>=',
        new Date(date.getMonth(), date.getDate(), date.getFullYear())
      )
      .orderBy('time', 'desc')
      .limit(3)
      .get();
    const finalList = listCollection.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setLists(finalList);

    // check if all list items are done with updated list
    // if it is, ask to archive or auto archive
    // auto archiving for now
    const listUpdate = await db
      .collection('lists')
      .doc(listId)
      .get();
    const updatedList = listUpdate.data();
    const listDone = updatedList.items.every(items => items.done === true);
    listDone
      ? await db
          .collection('lists')
          .doc(listId)
          .update({
            listDone: true
          })
      : await db
          .collection('lists')
          .doc(listId)
          .update({
            listDone: false
          });
  };

  const markShopper = async (buttonIndex, listId) => {
    const userDoc = await db.doc(`users/${user.uid}`).get();
    const { householdUid } = userDoc.data();
    const list = lists.filter(({ id }) => id === listId);
    const newList = { ...list[0] };
    let shopper = newList.shopper;
    const newArray = shopper.map(me => (me = false));
    newArray[buttonIndex] = true;
    const date = new Date();

    await db
      .collection('lists')
      .doc(listId)
      .update({
        shopper: [...newArray]
      });

    const listCollection = await db
      .collection('lists')
      .where('householdUid', '==', householdUid)
      .where('listDone', '==', false)
      .where(
        'time',
        '>=',
        new Date(date.getMonth(), date.getDate(), date.getFullYear())
      )
      .orderBy('time', 'desc')
      .limit(3)
      .get();
    const finalList = listCollection.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setLists(finalList);
  };

  return (
    <>
      {listLoading && <Loading />}
      {!listLoading && lists.length < 1 && (
        <CardWrapper>
          <h3>You don't have any lists at the moment!</h3>
          <NewList />
        </CardWrapper>
      )}
      {user && lists && (
        <>
          {lists.map((list, index) => {
            const { shopper, items, id } = list;
            return (
              <ItemCard
                key={id}
                list={list}
                listIndex={index}
                items={items}
                shopper={shopper}
                markItem={markItem}
                markShopper={markShopper}
              />
            );
          })}
        </>
      )}
    </>
  );
}
